import { MEMBER } from "@src/mock/data/member";

export default {
  title: '取得會員',
  type: 'get',
  body: [
    {
      title: '成功',
      body: {
        "code": 200,
        "message": "success",
        "status": "SUCCESS",
        "data": {
          "items": MEMBER,
        }
      }
    },
  ]
}

